// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R4hx","content":"styles_content__wV1U3","row":"styles_row__oKjgF","footer":"styles_footer__xKo_1","phraseLength":"styles_phraseLength__19TXa"};